import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'
import { CheckIcon } from '@heroicons/react/outline'
import { StyledCheckbox } from '.'

type Props = {
  direction?: 'ltr' | 'rtl';
  // ^ Handles the direction of the checkbox relative to text
  // ltr: Left to right (default), rtl: Right to left
  label?: string | ReactNode;
  className?: string;
  name: string;
  value?: string;
  children?: ReactNode;
  isChecked?: boolean;
  isDisabled?: boolean;
  [x: string]: any;
}

const Checkbox: FC<Props> = ({
  direction = 'ltr',
  label,
  className,
  name,
  value,
  children,
  isChecked,
  isDisabled,
  ...props
}) => {
  return (
    <StyledCheckbox
      direction={direction}
      isDisabled={isDisabled}
      className={classNames('checkbox', className)}
    >
      <div className="check-box">
        <input
          name={name}
          value={value}
          disabled={isDisabled}
          id={name}
          type="checkbox"
          checked={isChecked}
          {...props}
        />
        <CheckIcon />
      </div>
      {label && <label htmlFor={name}>{label}</label>}
      {children}
    </StyledCheckbox>
  )
}

export default Checkbox
